import client from './AxiosClient'

const transactionService = {
    getTransaction : (params) => client.get("/transactions", { params }),
}

export default transactionService;